<button mat-button [matMenuTriggerFor]="menu" class="user-menu">
  {{username}}
  <mat-icon><img src="assets/images/icon-user.svg" /></mat-icon>
</button>

<mat-menu #menu="matMenu" class="user-dropdown">
  <span class="dropdown-menu-arrow"></span>
  <button mat-menu-item routerLink="/ResetMyPassword">
    <mat-icon><img src="assets/images/icon-change-password.svg" /></mat-icon>
    <span>Change Password</span>
  </button>
  <button mat-menu-item routerLink="/Logout">
    <mat-icon><img src="assets/images/icon-signout.svg" /></mat-icon>
    <span>Sign Out</span>
  </button>
</mat-menu>

<a matTooltip="Help" target="_blank" mat-button class="user-menu help-button" [href]="helpURL">
  <mat-icon><img src="assets/images/icon-help.svg" /></mat-icon>
</a>
